import { Component, Input } from '@angular/core';
import { WorksheetItem, WorksheetType, Worksheet } from '@fgb/core';
import { IS_WORKSHEET_DISABLED } from '../token/is-disabled.token';

// Helper function to filter videos from group and flatten it into a single list
function filterByVideo(items: Worksheet[]): WorksheetItem[] {
  let _items: Worksheet[] = items ?? [];
  return _items.flatMap((group) =>
    (group.Items ?? [])
      .filter((item) => item.WorksheetType === WorksheetType.ProviderVideo)
      .map((item) => ({ ...item, WorksheetId: group.WorksheetId }))
  );
}
@Component({
  selector: 'fgb-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrl: './video-gallery.component.scss',
  providers: [
    {
      // use to disable video
      provide: IS_WORKSHEET_DISABLED,
      useFactory: () => false,
    },
  ],
})
export class VideoGalleryComponent {
  @Input({ transform: filterByVideo }) videos: WorksheetItem[] = [];
  selectedIndex: number = 0;

  constructor() {}

  onVideoSelect(event: { item: WorksheetItem & { WorksheetId: number }; index: number }): void {
    this.selectedIndex = event.index;
  }

  get selectedVideo(): WorksheetItem & { WorksheetId: number } {
    return this.videos[this.selectedIndex] as WorksheetItem & { WorksheetId: number };
  }
}
